import React from 'react';
import FirmsSection from './FirmsSection';
import JobNotificationsSection from './JobNotificationsSection';
import FormNotificationsSection from './FormNotificationsSection';
import EventsCalendarSection from './EventsCalendarSection';

const brand = {
  deepBlue:  '#0a2947',
  tealBlue:  '#0069a6',
  goldenrod: '#d09b2c',
  charcoal:  '#58585b',
  softGray:  '#e9e6e1',
};

export default function HRConfig() {
  return (
    <div style={{ background: brand.softGray, minHeight: '100vh', padding: '1.5rem' }}>

      <div style={{ background: brand.deepBlue, borderRadius: '12px', padding: '1.75rem 2rem', marginBottom: '1.5rem', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 0, right: 0, width: '300px', height: '100%', background: 'linear-gradient(135deg, transparent 40%, rgba(0,105,166,0.3))', pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: '3px', background: brand.goldenrod }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div style={{ background: 'rgba(208,155,44,0.15)', border: `2px solid ${brand.goldenrod}`, borderRadius: '12px', padding: '0.75rem', flexShrink: 0 }}>
            <i className="bi bi-sliders" style={{ color: brand.goldenrod, fontSize: '1.75rem' }} />
          </div>
          <div>
            <p style={{ color: brand.goldenrod, fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '2px', margin: '0 0 4px' }}>
              HR Portal
            </p>
            <h3 style={{ color: 'white', fontWeight: 800, margin: '0 0 4px' }}>Config</h3>
            <p style={{ color: 'rgba(255,255,255,0.65)', margin: 0, fontSize: '0.875rem' }}>
              Lookup values used throughout the HR portal.
            </p>
          </div>
        </div>
      </div>

      <FirmsSection />
      <JobNotificationsSection />
      <FormNotificationsSection />
      <EventsCalendarSection />
    </div>
  );
}
